import { render, staticRenderFns } from "./WhiteX.vue?vue&type=template&id=864652b6&"
import script from "./WhiteX.vue?vue&type=script&lang=js&"
export * from "./WhiteX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports